import { combineReducers } from "redux";

import actions from "../constants/hubReconciliationActions";
import {
  getFetchingState,
  getSuccessState,
  getErrorState,
  getResetState,
  createReducer,
} from "../utils/reducers";

const defaultState = {
  fetching: false,
  result: null,
  error: null,
};

const getHubReconciliationList = createReducer(defaultState, {
  [actions.GET_HUB_RECONCILIATION_LIST]: getFetchingState,
  [actions.GET_HUB_RECONCILIATION_LIST_SUCCESS]: getSuccessState,
  [actions.GET_HUB_RECONCILIATION_LIST_ERROR]: getErrorState,
  [actions.GET_HUB_RECONCILIATION_LIST_CLEAR]: getResetState,
});

const startHubReconciliation = createReducer(defaultState, {
  [actions.START_HUB_RECONCILIATION]: getFetchingState,
  [actions.START_HUB_RECONCILIATION_SUCCESS]: getSuccessState,
  [actions.START_HUB_RECONCILIATION_ERROR]: getErrorState,
  [actions.START_HUB_RECONCILIATION_CLEAR]: getResetState,
});

const scanBarcode = createReducer(defaultState, {
  [actions.SCAN_BARCODE]: getFetchingState,
  [actions.SCAN_BARCODE_SUCCESS]: getSuccessState,
  [actions.SCAN_BARCODE_ERROR]: getErrorState,
  [actions.SCAN_BARCODE_CLEAR]: getResetState,
});

const closeHubReconciliation = createReducer(defaultState, {
  [actions.CLOSE_HUB_RECONCILIATION]: getFetchingState,
  [actions.CLOSE_HUB_RECONCILIATION_SUCCESS]: getSuccessState,
  [actions.CLOSE_HUB_RECONCILIATION_ERROR]: getErrorState,
  [actions.CLOSE_HUB_RECONCILIATION_CLEAR]: getResetState,
});

const getReportData = createReducer(defaultState, {
  [actions.GET_REPORT_DATA]: getFetchingState,
  [actions.GET_REPORT_DATA_SUCCESS]: getSuccessState,
  [actions.GET_REPORT_DATA_ERROR]: getErrorState,
  [actions.GET_REPORT_DATA_CLEAR]: getResetState,
});

export default combineReducers({
  getHubReconciliationList,
  startHubReconciliation,
  scanBarcode,
  closeHubReconciliation,
  getReportData,
});
